/*!
 * Copyright © 2019-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EDeviceErrorType, EVehicleStatusType } from '../../../core/models';

@Component({
  selector: 'fm-no-vehicle-selected',
  templateUrl: './no-vehicle-selected.component.html',
  styleUrls: ['./no-vehicle-selected.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoVehicleSelectedComponent {
  @Input()
  public displayMessage: string;
  @Input()
  public vehicleStatusFilterSelected: EVehicleStatusType;
  @Input()
  public hasFleetConnected: boolean;
  @Input()
  public hasFleetSelected: boolean;
  @Input()
  public hasAttributeFilter: boolean;
  @Input()
  public hasAttributeError: boolean;

  public EVehicleStatusType = EVehicleStatusType;
  public EDeviceErrorType = EDeviceErrorType;
  public fleetConnectionHelpUrl = 'https://reveal-help.verizonconnect.com/hc/en-ie/articles/360010624659-Quick-start-checklist';

  @Output()
  public selectVehiclesClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  public retryFilterClicked: EventEmitter<void> = new EventEmitter<void>();

  public selectVehiclesClick(): void {
    this.selectVehiclesClicked.emit();
  }

  public retryFilterClick(): void {
    this.retryFilterClicked.emit();
  }
}
